import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";
const DashBoardServices = {
  getDashboardList: async () => {
    const response = await apiService.get(`/${slug}/dashboard/getdashboarddata`);
    return response.data;
  },
  getPaymentList: async () => {
    const response = await apiService.get(`/${slug}/dashboard/getpaymentdata`);
    return response.data;
  },

  getProductData: async () => {
    const response = await apiService.get(`/${slug}/dashboard/getproductsdata`);
    return response.data;
  },
 
};

export default DashBoardServices;
